import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import ComponentLoader from '../component-loader'
import './styles.scss'
import { useSelector } from 'react-redux'
import { usePrevious } from '../../../../../customHooks/usePrevious'
import { environment } from '../../../../../environment'

const GroupSingleAttributeSelectControlledPricing = ({
                                                       blueprint,
                                                       parentBlueprint,
                                                       factsheetBlueprint,
                                                       factInstanceKey,
                                                       collapsed,
                                                       deleteAttribute,
                                                     }) => {
  const controllingAttribute = useSelector(state => {
    if (!state.factsheet.facts[parentBlueprint.id]) {
      return null
    }
    if (!state.factsheet.facts[parentBlueprint.id][factInstanceKey].attributes) {
      return null
    }
    return state.factsheet.facts[parentBlueprint.id][factInstanceKey].attributes[blueprint.controllingAttributeId] ?? null
  })
  const [filteredComponents, setFilteredComponents] = useState([])
  const previousControllingAttribute = usePrevious(controllingAttribute)

  useEffect(() => {
    setFilteredComponents(blueprint.components.filter(
      component => (
        component.type === 'attribute:single-attribute-select'
        && component.options.some(option => option.id === blueprint.controllingAttributeId)
      ) || controllingAttribute !== null
    ))
  }, [
    blueprint,
    controllingAttribute,
  ])

  useEffect(() => {
    if (previousControllingAttribute === controllingAttribute) {
      return
    }
    if (!controllingAttribute) {
      blueprint.pricingAttributeIds.forEach(attributeId => {
        deleteAttribute(
          parentBlueprint.id,
          factInstanceKey,
          attributeId
        )
      })
    }
  }, [
    previousControllingAttribute,
    controllingAttribute,
    blueprint,
    deleteAttribute,
    factInstanceKey,
    parentBlueprint.id,
  ])

  const componentsToDisplay = filteredComponents.map((component, index) => {
    const keyUsed = component && component.id ? component.id : `${parentBlueprint.id}:i${index}`
    if (environment.IS_DEV && window.__LOG_FS_KEYS) {
      if (!component || !component.id) {
        console.warn('Factsheet key fallback used in GroupSingleAttributeSelectControlledPricing', {
          parentId: parentBlueprint.id,
          index,
          component
        })
      }
      console.debug('Factsheet key used (GroupSingleAttributeSelectControlledPricing):', keyUsed)
    }
    return (
      <ComponentLoader
        key={keyUsed}
        blueprint={component}
        parentBlueprint={parentBlueprint}
        factsheetBlueprint={factsheetBlueprint}
        factInstanceKey={factInstanceKey}
        collapsed={collapsed}
      />
    )
  })
  if (collapsed) {
    return componentsToDisplay
  }
  return (
    <div className="group-single-attribute-select-controlled-pricing">
      {
        componentsToDisplay
      }
    </div>
  )
}

GroupSingleAttributeSelectControlledPricing.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  collapsed: PropTypes.bool.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
}

export default GroupSingleAttributeSelectControlledPricing
